var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      attrs: { color: "background darken-1", "icons-and-text": "" },
      model: {
        value: _vm.current_tab,
        callback: function($$v) {
          _vm.current_tab = $$v
        },
        expression: "current_tab"
      }
    },
    [
      _c("v-tabs-slider", { attrs: { color: "primary" } }),
      _vm._v(" "),
      _c(
        "v-tab",
        { attrs: { href: "#tab-info" } },
        [_vm._v("\n\t\tInformations\n\t\t"), _c("v-icon", [_vm._v("help")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab",
        { attrs: { href: "#tab-qc", disabled: _vm.disable_qc } },
        [_vm._v("\n\t\tQC\n\t\t"), _c("v-icon", [_vm._v("thumbs_up_down")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab",
        { attrs: { href: "#tab-artefacts", disabled: !_vm.artefacts } },
        [
          _vm._v("\n\t\tArtefacts\n\t\t"),
          _c("v-icon", [_vm._v("auto_awesome_motion")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab",
        {
          attrs: {
            href: "#tab-locations",
            disabled: _vm.locations.length === 0
          }
        },
        [
          _vm._v("\n\t\tEmplacements\n\t\t"),
          _c("v-icon", [_vm._v("find_in_page")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab",
        { attrs: { href: "#tab-metadata", disabled: _vm.disable_babel } },
        [_vm._v("\n\t\tEditorial\n\t\t"), _c("v-icon", [_vm._v("assignment")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab",
        { attrs: { href: "#tab-debug" } },
        [_vm._v("\n\t\tData\n\t\t"), _c("v-icon", [_vm._v("code")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-info" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-5", attrs: { shrink: "" } },
                        [
                          _c("table", [
                            _c("tbody", [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "title primary--text pb-3",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tGénéral\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Ayant-droit")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-chip",
                                      {
                                        staticClass: "ma-0",
                                        attrs: {
                                          label: "",
                                          small: "",
                                          color: "background"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getter("t_aux.name")) +
                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("ID")]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.behive_url,
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "primary" }
                                        },
                                        [_vm._v("open_in_new")]
                                      ),
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(_vm.getter("id")) +
                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Référence labo")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0",
                                        attrs: {
                                          small: "",
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.copyToClipboard(
                                              _vm.getter("ref_material")
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getter("ref_material")) +
                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "ml-2",
                                            attrs: { small: "" }
                                          },
                                          [_vm._v("content_copy")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Type de support")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.getter("type_sup.lib_type_sup"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Poids")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.weight))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Type de stockage")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.getter("behive_category")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Dernière mise à jour")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.update_date))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Origine")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(_vm.getter("origin")))])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Proxy")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "py-0" },
                                  [
                                    _vm.getter("has_proxy") === true
                                      ? _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "success lighten-1"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tcheck\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "error lighten-1" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Rapport de Vérif")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "py-0" },
                                  [
                                    _vm.getter("has_rv") === true
                                      ? _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "success lighten-1"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tcheck\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "error lighten-1" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { shrink: "" } }, [
                        _c("table", [
                          _c("tbody", [
                            _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "title primary--text pb-3",
                                  attrs: { colspan: "2" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t\tProgramme\n\t\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Titre")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getter("title.name")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Titre secondaire")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getter("title.alternative")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Version Programme")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getter("program.version")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("th", [_vm._v("Type Programme")]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getter(
                                      "program.type_prgm.lib_type_prgm"
                                    )
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _vm.asset.program.no_episode
                              ? _c("tr", [
                                  _c("th", [_vm._v("N° Episode")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.getter("program.no_episode"))
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.asset.program.titre_epis_princ
                              ? _c("tr", [
                                  _c("th", [_vm._v("TItre Episode")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getter("program.titre_epis_princ")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.asset.program.serie
                              ? _c("tr", [
                                  _c("th", [_vm._v("Série ID")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getter("program.serie.serie_id")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.asset.program.serie
                              ? _c("tr", [
                                  _c("th", [_vm._v("Série N° Année")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getter("program.serie.no_annee")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.asset.program.serie
                              ? _c("tr", [
                                  _c("th", [_vm._v("Série Titre ID")]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getter("program.serie.titre_id")
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-qc" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                    _c(
                      "div",
                      { staticClass: "title primary--text pa-2 pl-4" },
                      [_vm._v("Info de mise à jour")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pa-2" }, [
                      _vm._v(_vm._s(_vm.getter("qc.update_info")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "primary mt-1" }),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-5", attrs: { shrink: "" } },
                        [
                          _c("table", [
                            _c(
                              "tbody",
                              [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "title primary--text pb-3",
                                      attrs: { colspan: "2" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tGénéral\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.asset.qc.general, function(
                                  value,
                                  key
                                ) {
                                  return _c("tr", { key: key }, [
                                    _c(
                                      "th",
                                      { staticClass: "text-capitalize" },
                                      [_vm._v(_vm._s(_vm.keyFormatter(key)))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [_vm._v(_vm._s(value || "-"))])
                                  ])
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pr-5", attrs: { shrink: "" } },
                        [
                          _c("table", [
                            _c(
                              "tbody",
                              [
                                _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "title primary--text pb-3",
                                      attrs: { colspan: "2" }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tDisplay\n\t\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.asset.qc.display, function(
                                  value,
                                  key
                                ) {
                                  return _c("tr", { key: key }, [
                                    _c(
                                      "th",
                                      { staticClass: "text-capitalize" },
                                      [_vm._v(_vm._s(_vm.keyFormatter(key)))]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      key === "aspect_ratio"
                                        ? _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s((value || {}).label) +
                                                " - " +
                                                _vm._s((value || {}).rounded) +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : key === "surface"
                                        ? _c("span", [
                                            _c("div", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\tborder: " +
                                                  _vm._s((value || {}).border) +
                                                  "%\n\t\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t\t\tpicture: " +
                                                  _vm._s(
                                                    (value || {}).picture
                                                  ) +
                                                  "%\n\t\t\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(value || "-") +
                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                    ])
                                  ])
                                })
                              ],
                              2
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pr-5", attrs: { shrink: "" } },
                        [
                          _c("table", [
                            _c("tbody", [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "title primary--text pb-3",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tPicture\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Width")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.getter("qc.picture.width")))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Height")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.getter("qc.picture.height"))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Aspect ratio")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getter(
                                        "qc.picture.aspect_ratio.rounded"
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pr-5", attrs: { shrink: "" } },
                        [
                          _c("table", [
                            _c("tbody", [
                              _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticClass: "title primary--text pb-3",
                                    attrs: { colspan: "2" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t\tValidation\n\t\t\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Validé")]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _vm.getter("qc.validation.validated") ===
                                    true
                                      ? _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: "success lighten-1"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tcheck\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-icon",
                                          {
                                            attrs: { color: "error lighten-1" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("th", [_vm._v("Commentaire")]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.getter("qc.validation.comment"))
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.audio_channels.length > 0
                        ? _c(
                            "v-flex",
                            { staticClass: "pr-5", attrs: { shrink: "" } },
                            [
                              _c("table", [
                                _c(
                                  "tbody",
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "title primary--text pb-3",
                                          attrs: { colspan: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\tAudio\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Source")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Type")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Langue")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Mix")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Mapping")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Norme")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Codec")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Dial norm")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Loudness algo")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Loudness")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Lra")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("True peak")])
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.audio_channels, function(
                                      channel,
                                      i
                                    ) {
                                      return _c("tr", { key: "content" + i }, [
                                        _c("td", [
                                          _vm._v(_vm._s(channel.src_index))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.version_type || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.language || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.mix_type || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(channel.mapping || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(channel.norm || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(channel.codec || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.dial_norm || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.loudness_algo || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.loudness || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(channel.lra || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(channel.true_peak || "-")
                                          )
                                        ])
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.program_content.length > 0
                        ? _c(
                            "v-flex",
                            { staticClass: "pr-5", attrs: { shrink: "" } },
                            [
                              _c("table", [
                                _c(
                                  "tbody",
                                  [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "title primary--text pb-3",
                                          attrs: { colspan: "2" }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\tContenu\n\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Désignation")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Description")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Début")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Fin")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Durée")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Localisation")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Partie")])
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.program_content, function(
                                      content,
                                      i
                                    ) {
                                      return _c("tr", { key: "content" + i }, [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(content.designation || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(content.description || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(content.tc_in || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(content.tc_out || "-"))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(content.duration || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(content.localization || "-")
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(content.part || "-"))
                                        ])
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-artefacts" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _vm.artefacts
                ? _c(
                    "v-card-text",
                    [
                      _vm.artefacts.screenshots.length
                        ? _c(
                            "v-container",
                            {
                              staticClass: "pa-0",
                              attrs: { "grid-list-md": "", fluid: "" }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                _vm._l(_vm.artefacts.thumbnails, function(
                                  screenshot,
                                  i
                                ) {
                                  return _c(
                                    "v-flex",
                                    {
                                      key: screenshot,
                                      attrs: { xs4: "", "d-flex": "" }
                                    },
                                    [
                                      _c("v-hover", {
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var hover = ref.hover
                                                return _c(
                                                  "v-card",
                                                  {
                                                    staticClass: "d-flex",
                                                    class:
                                                      "elevation-" +
                                                      (hover ? 12 : 2),
                                                    attrs: {
                                                      flat: "",
                                                      tile: ""
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-img",
                                                      {
                                                        staticClass:
                                                          "grey lighten-2",
                                                        attrs: {
                                                          src:
                                                            _vm.artefacts.url +
                                                            screenshot +
                                                            _vm.artefacts
                                                              .signature
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.openScreenshots(
                                                              i
                                                            )
                                                          }
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key:
                                                                "placeholder",
                                                              fn: function() {
                                                                return [
                                                                  _c(
                                                                    "v-layout",
                                                                    {
                                                                      attrs: {
                                                                        "fill-height":
                                                                          "",
                                                                        "align-center":
                                                                          "",
                                                                        "justify-center":
                                                                          "",
                                                                        "ma-0":
                                                                          ""
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-progress-circular",
                                                                        {
                                                                          attrs: {
                                                                            indeterminate:
                                                                              "",
                                                                            color:
                                                                              "grey lighten-5"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                ]
                                                              },
                                                              proxy: true
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      },
                                                      [
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-expand-transition",
                                                          [
                                                            hover
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex transition-fast-in-fast-out primary v-card--reveal",
                                                                    staticStyle: {
                                                                      height:
                                                                        "100%"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          size: 100,
                                                                          color:
                                                                            "color"
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "fullscreen"
                                                                        )
                                                                      ]
                                                                    )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { attrs: { id: "screenshot-viewer" } }),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        {
                          staticClass: "pa-0",
                          attrs: { "grid-list-md": "", fluid: "" }
                        },
                        _vm._l(_vm.artefacts.audio, function(val, key, i) {
                          return _c(
                            "v-layout",
                            { key: "audio" + i, attrs: { row: "", wrap: "" } },
                            [
                              _c("div", {
                                staticClass: "zoomview",
                                attrs: { id: "zoomview-" + key }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "overview",
                                attrs: { id: "overview-" + key }
                              }),
                              _vm._v(" "),
                              _c("audio", {
                                attrs: {
                                  id: "audio-" + key,
                                  controls: "",
                                  src:
                                    _vm.artefacts.url +
                                    val.wav +
                                    _vm.artefacts.signature
                                }
                              })
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-locations" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                _vm._l(_vm.locations, function(location, i) {
                  return _c(
                    "div",
                    {
                      key: "location_" + i,
                      staticClass: "location",
                      style:
                        "border: 1px solid var(--v-" + location.color + "-base)"
                    },
                    [
                      _c("div", [
                        _vm.is_admin
                          ? _c(
                              "span",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "mt-0 ml-0",
                                    attrs: {
                                      small: "",
                                      color: "primary color--text",
                                      href:
                                        "" +
                                        _vm.t1000_url +
                                        location.id +
                                        "/change/",
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "", color: "color" }
                                      },
                                      [_vm._v("open_in_new")]
                                    ),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t#" +
                                        _vm._s(location.id) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c(
                              "span",
                              [
                                _c(
                                  "v-chip",
                                  {
                                    staticClass: "mt-0 ml-0",
                                    attrs: {
                                      label: "",
                                      small: "",
                                      color: "primary",
                                      "text-color": "color"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t#" +
                                        _vm._s(location.id) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "pl-2" },
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass: "mt-0 ml-0",
                                attrs: {
                                  label: "",
                                  outline: "",
                                  small: "",
                                  color:
                                    location.status === 1
                                      ? "green accent-3"
                                      : "red accent-2"
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(location.status_text) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "pl-2",
                            attrs: {
                              title: _vm.$time.fromDate(location.creation_date)
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tcréée le " +
                                _vm._s(
                                  _vm._f("formatDate2")(location.creation_date)
                                ) +
                                "\n\t\t\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        location.creation_jobrequest
                          ? _c(
                              "span",
                              { staticClass: "pl-2" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tVia le job\n\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: {
                                      to: {
                                        name: "Maestro job",
                                        params: {
                                          jr_id: location.creation_jobrequest
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("open_in_new")
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(location.creation_jobrequest) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "storage-category" },
                          [
                            _c(
                              "v-icon",
                              { attrs: { size: 200, color: location.color } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(location.icon) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2" }, [
                        location.absolute_path.indexOf("/media/DATA/") === 0
                          ? _c(
                              "span",
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: {
                                      to: {
                                        name: "Filesystem",
                                        query: { path: location.absolute_path }
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("open_in_new")
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(location.absolute_path) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(location.absolute_path) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pt-2",
                          class: location.last_check_is_valid
                            ? "green--text text--accent-3"
                            : "red--text text--accent-2"
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: {
                                title: _vm.$time.fromDate(
                                  location.last_check_date
                                )
                              }
                            },
                            [
                              location.last_check_is_valid
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        color: "green accent-3",
                                        small: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tcheck_box\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        color: "red accent-2",
                                        small: ""
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                              _vm._v(
                                "\n\t\t\t\t\t\t\tDernière vérification\n\t\t\t\t\t\t\t"
                              ),
                              location.last_check_date
                                ? _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tle " +
                                        _vm._s(
                                          _vm._f("formatDate2")(
                                            location.last_check_date
                                          )
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tinconnue\n\t\t\t\t\t\t\t"
                                    )
                                  ])
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2" }, [
                        _c(
                          "span",
                          {
                            class: location.is_nearline
                              ? "green--text text--accent-3"
                              : "red--text text--accent-2"
                          },
                          [
                            location.is_nearline
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      color: "green accent-3",
                                      small: ""
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tcheck_box\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              : _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-1",
                                    attrs: { color: "red accent-2", small: "" }
                                  },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tblock\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                ),
                            _vm._v("\n\t\t\t\t\t\t\tNearline\n\t\t\t\t\t\t")
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2" }, [
                        _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.$time.fromDate(location.deletion_date)
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\tSuppression le\n\t\t\t\t\t\t\t"
                            ),
                            _c("span", { staticClass: "pl-2" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("formatDate2")(
                                      location.deletion_date
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2" }, [
                        _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.$time.fromDate(location.expiring.date)
                            }
                          },
                          [
                            _vm._v("\n\t\t\t\t\t\t\tExpire le\n\t\t\t\t\t\t\t"),
                            _c("span", { staticClass: "pl-2" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm._f("formatDate2")(
                                      location.expiring.date
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t\t"
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        location.expiring.jobrequest_id
                          ? _c(
                              "span",
                              { staticClass: "pl-2" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\tVia le job\n\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "link",
                                    attrs: {
                                      to: {
                                        name: "Maestro job",
                                        params: {
                                          jr_id: location.expiring.jobrequest_id
                                        }
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("open_in_new")
                                    ]),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          location.expiring.jobrequest_id
                                        ) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        location.expiring.jobdescriptor
                          ? _c("span", { staticClass: "pl-2" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\tDescripteur " +
                                  _vm._s(location.expiring.jobdescriptor) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pt-2" }, [
                        _c("span", [_vm._v("Stockage")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          [
                            _c(
                              "v-icon",
                              { attrs: { small: "", color: location.color } },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(location.icon) +
                                    "\n\t\t\t\t\t\t\t"
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            style:
                              "color: var(--v-" + location.color + "-lighten1)"
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t" +
                                _vm._s(location.storage.category) +
                                "\n\t\t\t\t\t\t\t(" +
                                _vm._s(location.storage.family) +
                                ")\n\t\t\t\t\t\t\t" +
                                _vm._s(location.storage.name) +
                                "\n\t\t\t\t\t\t\t(#" +
                                _vm._s(location.storage.id) +
                                ")\n\t\t\t\t\t\t"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      location.analysis
                        ? _c("div", { staticClass: "pt-2" }, [
                            location.analysis.length
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\tAnalyse\n\t\t\t\t\t\t\t"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _c("table", [
                                      _c(
                                        "tbody",
                                        _vm._l(location.analysis, function(
                                          analysis,
                                          index
                                        ) {
                                          return _c(
                                            "tr",
                                            { key: "analysis_" + index },
                                            [
                                              _c("td", [
                                                _vm._v(_vm._s(analysis.code))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(analysis.level))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(analysis.name))
                                              ])
                                            ]
                                          )
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                0
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-metadata" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._l(_vm.edito, function(edito, i) {
                    return _c(
                      "div",
                      { key: "edito" + i },
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: { row: "", wrap: "", "justify-center": "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { staticClass: "pr-0", attrs: { xs6: "" } },
                              [
                                _c("table", [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "title primary--text pb-3",
                                          attrs: { colspan: "4" }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                              _vm._s(edito.card_type) +
                                              "\n\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("ID")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.id))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Creation Date")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(edito.creation_date))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Last Update")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(edito.last_update))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Title")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.title))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Title Language")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(edito.title_language))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Episode Num")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(edito.episode_num))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Duration")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.duration))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Production Year")]),
                                      _vm._v(" "),
                                      _c("td", [
                                        _vm._v(_vm._s(edito.production_year))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Type")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.type))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Genre")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.genre))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Target")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.target))])
                                    ]),
                                    _vm._v(" "),
                                    _c("tr", [
                                      _c("th", [_vm._v("Synopsis")]),
                                      _vm._v(" "),
                                      _c("td", [_vm._v(_vm._s(edito.synopsis))])
                                    ]),
                                    _vm._v(" "),
                                    edito.casting.length > 0
                                      ? _c("tr", [
                                          _c("th", [_vm._v("Casting")]),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "pa-0" }, [
                                            _c(
                                              "table",
                                              _vm._l(edito.casting, function(
                                                cast,
                                                i
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: "cast" + i },
                                                  [
                                                    _c("th", [
                                                      _vm._v(_vm._s(cast.role))
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(_vm._s(cast.name))
                                                    ])
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { staticClass: "pl-0", attrs: { xs6: "" } },
                              [
                                _c("table", [
                                  _c(
                                    "tbody",
                                    [
                                      _c("tr", [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "title primary--text pb-3",
                                            attrs: { colspan: "2" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tLocalized Info\n\t\t\t\t\t\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(edito.localized_info, function(
                                        locale,
                                        i
                                      ) {
                                        return _c("tr", { key: "locale" + i }, [
                                          _c(
                                            "th",
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "font-weight-bold",
                                                  attrs: {
                                                    label: "",
                                                    color: "primary color--text"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                      _vm._s(locale.language) +
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", { staticClass: "pa-0" }, [
                                            _c("table", [
                                              _c("tr", [
                                                _c("th", [_vm._v("language")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(locale.language)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("title")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(locale.title))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [
                                                  _vm._v("origin_country")
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      locale.origin_country
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("target")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(locale.target))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("synopsis")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(locale.synopsis)
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("genre")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(locale.genre))
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("th", [_vm._v("type")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(_vm._s(locale.type))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      })
                                    ],
                                    2
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider", { staticClass: "primary" })
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c("tree-view", {
                        attrs: {
                          data: _vm.asset.babel,
                          options: {
                            maxDepth: 0,
                            rootObjectKey: "Données Brutes"
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tab-item",
        { attrs: { value: "tab-debug" } },
        [
          _c(
            "v-card",
            { staticClass: "background darken-1", attrs: { flat: "" } },
            [
              _c(
                "v-card-text",
                [
                  _vm.asset
                    ? _c("tree-view", {
                        attrs: {
                          data: _vm.asset,
                          options: { maxDepth: 1, rootObjectKey: "ASSET" }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-748c81e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-748c81e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/asset.vue
// module id = null
// module chunks = 